var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"botton"},[_vm._v(" @店开知识共享平台 BY 2023    浙ICP备20016250号-1 ")])])
}]

export { render, staticRenderFns }